import { useEffect, useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import { PARTNER_REDIRECTS } from "../sst/lib/partnerRedirects";

const baseURL = import.meta.env.VITE_API_URL || "/";

const REF_PARAM = "ref";

const isSelfReferential = (target: string): boolean => {
    try {
        const url = new URL(target, window.location.href);
        return url.origin === window.location.origin && url.pathname === window.location.pathname;
    } catch {
        return true;
    }
};

export const PartnerRedirect = () => {
    const { partner, area } = useParams<{ partner: string; area: string }>();

    const currentParams = new URLSearchParams(window.location.search);
    const ref = currentParams.get(REF_PARAM);

    const [resolvingRedirect, setResolvingRedirect] = useState(Boolean(ref));

    useEffect(() => {
        if (!ref) return;

        let cancelled = false;

        fetch(`${baseURL}/api/public/referral-links/${encodeURIComponent(ref)}/redirect`)
            .then((res) => (res.ok ? res.json() : null))
            .then((data: { redirectUrl?: string | null } | null) => {
                if (cancelled) return;
                const target = data?.redirectUrl;
                if (target && !isSelfReferential(target)) {
                    window.location.replace(target);
                    return;
                }
                setResolvingRedirect(false);
            })
            .catch(() => {
                if (!cancelled) setResolvingRedirect(false);
            });

        return () => {
            cancelled = true;
        };
    }, [ref]);

    if (resolvingRedirect) {
        return <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>Loading…</div>;
    }

    currentParams.delete(REF_PARAM);

    if (!partner) {
        return <Redirect to={`/search?${currentParams.toString()}`} />;
    }

    currentParams.set("utm_source", partner);
    if (area) {
        currentParams.set("area", area);
    }

    if (PARTNER_REDIRECTS[partner]) {
        const to =
            area && PARTNER_REDIRECTS[partner][area]
                ? PARTNER_REDIRECTS[partner][area]
                : PARTNER_REDIRECTS[partner].default;

        const [path, search] = to.split("?");
        const targetSearchParams = new URLSearchParams(search);
        currentParams.forEach((value, key) => {
            if (!targetSearchParams.has(key)) {
                targetSearchParams.set(key, value);
            }
        });

        return <Redirect to={`${path}?${targetSearchParams.toString()}`} />;
    }

    return <Redirect to={`/search?${currentParams.toString()}`} />;
};
